export { default } from './es/icons/Right2Filled';